/**
 * Register custom SurveyJS properties used by exit tickets.
 * Must be imported before creating any SurveyJS Model instances.
 */
import { Serializer } from "survey-core";

Serializer.addProperty("question", {
  name: "generatedAudio",
  type: "string",
  default: "",
});
Serializer.addProperty("question", {
  name: "generatedAudioKey",
  type: "string",
  default: "",
});
Serializer.addProperty("question", {
  name: "isMath",
  type: "boolean",
  default: false,
});
Serializer.addProperty("question", {
  name: "matchingMode",
  type: "string",
  default: "Loose AI match",
});
Serializer.addProperty("question", {
  name: "matchingPrompt",
  type: "string",
  default: "",
});
Serializer.addProperty("question", {
  name: "correctAnswer",
  type: "string",
  default: "",
});
Serializer.addProperty("question", {
  name: "question",
  type: "string",
  default: "",
});

Serializer.addProperty("itemvalue", {
  name: "imageUrl",
  type: "string",
  default: "",
});
